import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { isNative } from "@/lib/mobile";

export default function NativeNavigation() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    if (!isNative) return;
    const back = Capacitor.getPlatform() === "android" ? App.addListener("backButton", ({ canGoBack }) => {
      if (document.querySelector('[role="dialog"]')) {
        document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true }));
      } else if (pathname !== "/" && pathname !== "/login") {
        if (canGoBack) navigate(-1); else navigate("/", { replace: true });
      } else App.exitApp();
    }) : null;
    const external = (event) => {
      const anchor = event.target.closest?.('a[target="_blank"]');
      if (!anchor) return;
      const url = new URL(anchor.href);
      if (url.protocol !== "https:") return;
      event.preventDefault();
      Browser.open({ url: url.href }).catch(() => { window.open(url.href, "_system"); });
    };
    document.addEventListener("click", external);
    return () => {
      back?.then((listener) => listener.remove());
      document.removeEventListener("click", external);
    };
  }, [navigate, pathname]);
  return null;
}
